/* 
 *  Created by SGiri 03/19/2018
 */

import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AdminService } from '~admin/services/admin.service';
import { CommonService } from '~util/common.service';
import { ActionDialogComponent } from '~admin/action-dialog/action-dialog.component';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.css']
})
export class ActionComponent implements OnInit {


  params: any;

  constructor(private dialog: MatDialog, private service: AdminService, private commonService: CommonService) {
  }
  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
  }

  refresh(status: string) {
    this.params.data.status = status;
    this.params.api.gridCore.gridOptions.api.hideOverlay();
    this.params.api.gridCore.gridOptions.api.refreshCells();
  }

  openDialog(action) {
    let header = 'Request Detail';
    if (action === 'rollback') {
      header = 'Rollback Detail';
    }

    let dialogRef = this.dialog.open(ActionDialogComponent, {
      width: '900px',
      autoFocus: false,
      data: {
        action: action,
        header: header,
        params: this.params
      }
    });
  }

  delete() {

    this.params.api.gridCore.gridOptions.api.showLoadingOverlay();

    this.service.delete(this.params.data).subscribe(() => {
      this.commonService.reload();
    }, (error) => {
      let data = {
        isError: true,
        message: 'Request to delete this request was unsuccessful.  Contact support.'
      }
      this.commonService.showDialog(data);
    });
  }

  deny() {

    this.params.api.gridCore.gridOptions.api.showLoadingOverlay();

    this.service.deny(this.params.data).subscribe(() => {
      this.commonService.reload();
    }, (error) => {
      let data = {
        isError: true,
        message: 'Request to deny this request was unsuccessful.  Contact support.'
      }
      this.params.api.gridCore.gridOptions.api.hideOverlay();
      this.commonService.showDialog(data);
    });
  }

  approve() {

    this.params.api.gridCore.gridOptions.api.showLoadingOverlay();

    this.service.approve(this.params.data).subscribe(() => {
      this.commonService.reload();
    }, (error) => {

      let message = 'Request to approve this request was unsuccessful.  Contact support.'
      if (error.status === 403) {
        message = 'You do not have permissions to approve this request.'
      }
      let data = {
        isError: true,
        message: message
      }
      this.params.api.gridCore.gridOptions.api.hideOverlay();
      this.commonService.showDialog(data);
    });
  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/action/action.component.ts